import { Modal } from "@components/Modal";
import { FC, useState } from "react";
import { useTranslation } from "@helpers/useTranslation";

type Props = {
  show: boolean;
  onCancel: () => void;
  onConfirm: (paymentUrl: string, shareWinningsWithHost: boolean) => void;
  initialPaymentUrl?: string;
  initialShareWinningsWithHost?: boolean;
  onOpenBettingModal: () => void;
  onCloseBettingModal: () => void;
};

export const BettingConfigModal: FC<Props> = ({
  show,
  onCancel,
  onConfirm,
  onOpenBettingModal,
  onCloseBettingModal,
  initialPaymentUrl = "",
  initialShareWinningsWithHost = false,
}) => {
  const { t } = useTranslation("admin");
  const [paymentUrl, setPaymentUrl] = useState(initialPaymentUrl);
  const [shareWinningsWithHost, setShareWinningsWithHost] = useState(initialShareWinningsWithHost);

  if (!show) return null;

  const handleConfirm = () => {
    onConfirm(paymentUrl, shareWinningsWithHost);
    onCancel();
  };

  return (
    <Modal show={show} onCancel={onCancel} className="z-60" size="md">
      <h3 className="text-lg font-bold">{t("enableBetting")}</h3>
      <p className="py-4">{t("bettingEnabledConfirm")}</p>
      <div className="flex justify-center pt-2 pb-4">
        <button
          type="button"
          className="text-sm text-primary underline hover:opacity-80"
          onClick={() => onOpenBettingModal()}
        >
          {t("howDoesItWork")}
        </button>
      </div>

      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {t("adminPaymentUrl")}
        </label>
        <input
          type="text"
          placeholder={t("adminPaymentUrlPlaceholder")}
          value={paymentUrl}
          onChange={(e) => setPaymentUrl(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"
        />
        <p className="text-sm text-gray-600 mt-1">{t("adminPaymentUrlHelp")}</p>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <label className="block text-sm font-medium text-gray-700">
              {t("shareWinningsWithHost")}
            </label>
            <p className="text-sm text-gray-600 mt-1">{t("shareWinningsWithHostHelp")}</p>
          </div>
          <input
            type="checkbox"
            checked={shareWinningsWithHost}
            onChange={(e) => setShareWinningsWithHost(e.target.checked)}
            className="toggle toggle-primary ml-4"
          />
        </div>
      </div>

      <div className="flex flex-col px-4 py-3">
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md bg-green-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-green-500 sm:w-auto"
          onClick={handleConfirm}
        >
          {t("enable")}
        </button>
        <button
          type="button"
          className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:w-auto"
          onClick={onCancel}
        >
          {t("cancel")}
        </button>
      </div>
    </Modal>
  );
};
